<invalid-files-modal>
    <dialog class="modal" ref="dialog" aria-labelledby="invalid-files-modal-heading">
        <div class="modal-box">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}">
                    <i class="icon-clear"></i>
                </button>
            </form>

            <h3 id="invalid-files-modal-heading" class="font-bold text-lg mb-2 text-primary">
                {locale?.t('modal_invalidfiles_title')}
            </h3>

            <p class="mb-2 font-semibold">
                {locale?.t('modal_invalidfiles_description')}:
            </p>

            <ul class="mb-4 ps-4 list-disc">
                <li each="{name in state.invalidFileNames}" class="font-semibold break-words pb-1">
                    {name}
                </li>
            </ul>

            <div class="modal-action">
                <form method="dialog" class="flex gap-2">
                    <button class="btn text-primary rounded-lg"
                            aria-label="{locale?.t('close')}">{locale?.t('close')}</button>
                </form>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        export default {
            state: {
                invalidFileNames: []
            },

            show(invalidFileNames) {
                this.update({
                    invalidFileNames
                })
                this.$('dialog').show()
            },

            close() {
                this.$('dialog').close()
            },

            onMounted() {
                // Make globally accessible
                window.invalidFilesModal = this
            }
        }
    </script>
</invalid-files-modal>